import React, { useState } from 'react';
import usePageTitle from '../hooks/usePageTitle';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Gallery = () => {
  usePageTitle('Gallery');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [lightboxImage, setLightboxImage] = useState(null);

  const galleryItems = [
    {
      id: 1,
      title: "Project Completion",
      category: "project",
      image: "/images/gallery/project-completion-1.jpg",
      description: "Successful completion of major infrastructure project."
    },
    {
      id: 2,
      title: "Company Event",
      category: "events",
      image: "/images/gallery/company-event-1.jpg",
      description: "Annual company gathering and team building."
    },
    {
      id: 3,
      title: "Certificate & Achievement",
      category: "certificate",
      image: "/images/gallery/certificate-1.jpg",
      description: "Awarded for excellence in fiber optic contracting."
    },
    {
      id: 4,
      title: "Legal Document",
      category: "legal",
      image: "/images/gallery/legal-doc-1.jpg",
      description: "Official legal documentation for completed projects."
    }
  ];

  const categories = [
    { id: 'all', name: 'All' },
    { id: 'project', name: 'Project' },
    { id: 'events', name: 'Events' },
    { id: 'certificate', name: 'Certificate & Achievement' },
    { id: 'legal', name: 'Legal Docs' }
  ];

  const filteredItems = selectedCategory === 'all' 
    ? galleryItems 
    : galleryItems.filter(item => item.category === selectedCategory);

  const openLightbox = (image) => {
    setLightboxImage(image);
  };

  const closeLightbox = () => {
    setLightboxImage(null);
  };

  return (
    <div className="gallery-page">
      <Header />
      
      <main className="main-content">
        <section className="gallery-hero">
          <div className="container">
            <div className="hero-content">
              <h1>Project Gallery</h1>
              <p>Explore our portfolio of successful fiber optic installations, infrastructure projects, and technical achievements across Indonesia.</p>
            </div>
          </div>
        </section>

        <section className="gallery-section">
          <div className="container">
            <div className="gallery-filters">
              {categories.map(category => (
                <button
                  key={category.id}
                  className={`filter-btn ${selectedCategory === category.id ? 'active' : ''}`}
                  onClick={() => setSelectedCategory(category.id)}
                >
                  {category.name}
                </button>
              ))}
            </div>

            <div className="gallery-grid">
              {filteredItems.map(item => (
                <div key={item.id} className="gallery-item" onClick={() => openLightbox(item)}>
                  <div className="gallery-image">
                    <div className="gallery-placeholder">
                      <i className="fas fa-image"></i>
                    </div>
                    <div className="gallery-overlay">
                      <div className="gallery-info">
                        <h3>{item.title}</h3>
                        <p>{item.description}</p>
                      </div>
                      <div className="gallery-zoom">
                        <i className="fas fa-search-plus"></i>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {filteredItems.length === 0 && (
              <div className="no-results">
                <p>No projects found in this category.</p>
              </div>
            )}
          </div>
        </section>

        <section className="gallery-stats">
          <div className="container">
            <div className="stats-grid">
              <div className="stat-item">
                <div className="stat-number">150+</div>
                <div className="stat-label">Projects Completed</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">50+</div>
                <div className="stat-label">Cities Covered</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">10,000+</div>
                <div className="stat-label">Connections Installed</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">99.9%</div>
                <div className="stat-label">Uptime Achieved</div>
              </div>
            </div>
          </div>
        </section>

        <section className="gallery-cta">
          <div className="container">
            <div className="cta-content">
              <h2>Ready to Start Your Project?</h2>
              <p>Join our growing list of satisfied customers with reliable fiber optic solutions.</p>
              <button className="cta-btn">Get Started Today</button>
            </div>
          </div>
        </section>
      </main>

      {/* Lightbox Modal */}
      {lightboxImage && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close" onClick={closeLightbox}>
              <i className="fas fa-times"></i>
            </button>
            <div className="lightbox-image">
              <div className="lightbox-placeholder">
                <i className="fas fa-image"></i>
              </div>
            </div>
            <div className="lightbox-info">
              <h3>{lightboxImage.title}</h3>
              <p>{lightboxImage.description}</p>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Gallery;